import React from 'react';
import { IPhraseDetailsTabTranslationNativeLangProps } from './types';
import { Box, Stack, Tooltip, tooltipClasses } from '@mui/material';
import { theme } from '../../../../../../../common/styles/theme';
import { Text } from '../../../../../../../common/components/Text/Text';
import { HelpIcon } from '../../../../../../../../icons/HelpIcon';
import IconButton from '@mui/material/IconButton';
import { Wording } from '../wordings';

export const PhraseDetailsTabTranslationNativeLang: React.FC<IPhraseDetailsTabTranslationNativeLangProps> = ({
	langName,
	color,
	helpMessage,
	onOpenGroup
}) => {

	const bodyStyle = {
		position: 'relative',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: theme.spacing(5),
		px: theme.spacing(1.5),
		background: theme.palette.common.white,
		borderRadius: theme.spacing(1),
		border: `${theme.spacing(0.25)} solid ${theme.palette.grey[200]}`,
		'&:hover,&:focus,&:active': {
			borderColor: theme.palette.grey[300]
		},

		'&:hover .drag-icon': {
			opacity: 1,
		},
	}

	const textStyle = {
		flexGrow: 1,
		p: theme.spacing(0.5, 1, 0.5, 0),
		lineHeight: 1.2,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
		color
	};

	const onClickTooltip = (e: React.SyntheticEvent) => {
		const target = e.target as HTMLElement;
		if (target.className === 'playlist_name') {
			onOpenGroup();
		}
	}

	return (
				<Stack
					direction={'row'}
					sx={bodyStyle}
				>
					<Text
						fontWeight={600}
						noWrap
						variant={'subtitle2'}
						sx={textStyle}
					>
						{langName}
					</Text>

					<Stack
						direction={'row'}
						alignItems={'center'}
						gap={theme.spacing(0.5)}
					>

						<Stack
							direction='row'
							spacing={theme.spacing()}
							alignItems={'center'}
							sx={{
								pr: theme.spacing(0)
							}}
						>

							<Tooltip
								title={<Box
									onClick={onClickTooltip}
									dangerouslySetInnerHTML={{ __html: helpMessage}}
									sx={{
										'.playlist_name': {
											cursor: 'pointer',
											textDecoration: 'underline',

											'&:hover': {
												textDecoration: 'none',
											},
										},
										'p': {
											m: '0 0 .5em',
										},
									}}
								/>}
								placement={'right'}
								PopperProps={{
									sx: {
										[`.${tooltipClasses.tooltip}`]: {
											padding: `0 ${theme.spacing(2)} !important`,
											backgroundColor: 'rgba(50, 50, 50, .5)',
											backdropFilter: 'blur(20px)',
										},
									},
								}}
							>
								<IconButton
									color={'primary'}
									sx={{
										px: 0,
										color: theme.palette.grey[400],
										'.MuiSvgIcon-root': {
											width: theme.spacing(2),
											height: theme.spacing(2),
										},
										'&:hover, &:focus': {
											color: theme.palette.grey[600],
										}
									}}
								>
									<HelpIcon />
								</IconButton>
							</Tooltip>
						</Stack>
					</Stack>
				</Stack>

	);

}
